import { Box, Container, Grid } from '@chakra-ui/react';
import { Image, pxToRem } from '@cyberkongz/ui';
import { PageSEOTags } from '@features/seo/SEO';

export default function WellsResponsePage() {
  return (
    <Box width="100%">
      <PageSEOTags pageKey="wells-response" />
      <Container pt={pxToRem(100)} pb={4}>
        <Grid gap={2} mb={4}>
          <Box>
            This submission to the SEC, made in response to the Wells Notice, aims to provide clear
            and comprehensive insights into the CyberKongz ecosystem. Our objective is to assist the
            commissioners in thoroughly understanding the facts.
          </Box>
          <Box>
            This document presents a detailed explanation demonstrating why the sale of Genesis
            Kongz and the subsequent distribution of Banana tokens do not satisfy the criteria of a
            security under the Howey test.
          </Box>
          <Box>
            Furthermore, we articulate sound reasoning to establish why creators of NFT projects
            should not be classified as unregistered Broker-Dealers.
          </Box>
          <Box>
            With consideration for the privacy of those involved, personal names have been omitted.
          </Box>
        </Grid>
        <Grid gap={2}>
          {Array.from({ length: 17 }).map((_, i) => (
            <Image
              key={i}
              src={`/static/wells_response/CyberKongz_Wells_Submission_January_7_2025_001_Redacted-images-${i}.jpg`}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
